<template>
  <MainWrapper>
    <div class="single-master-page">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="container-fluid no-p">
                        <div class="row">
                            <div class="col-lg-6">
                                <h1 class="mb-15">{{ news.title }}</h1>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-8 more-info-holder mb-30">
                                <div class="more-info mr-40 gray-body-text">
                                    <font-awesome-icon class="icon mr-10" :icon="['fal', 'calendar-alt']" />
                                    <span>{{ moment(news.created_at).format('DD.MM.YYYY') }}</span>
                                </div>
                                <div class="more-info gray-body-text">
                                    <font-awesome-icon class="icon mr-10" :icon="['fal', 'glasses']" />
                                    <span>123</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-8">
                                <div class="news-body mb-40" v-html="news.text">
                                    
                                </div>
                            </div>
                        </div>
                        <!--div class="row">
                            <div class="col-lg-8">
                                <Button text="Поделиться" class="mr-10" type="blue" iconType="fab" icon="facebook"/>
                                <Button text="Поделиться" type="blue" iconType="fab" icon="odnoklassniki"/>
                            </div>
                        </div-->
                    </div>
                </div>
            </div>
        </div>
    </div>
  </MainWrapper>
</template>
<style lang="stylus" scoped>
    @import '../styles/main.core.vars.styl';

    h1
        color: $dark_black_text
        line-height: 39px

    .more-info-holder
        display: flex

    .news-body
        p
            margin-bottom: 15px
    
</style>
<script>
    import { Component, Vue, Watch } from "vue-property-decorator";
    import MainWrapper from '@/wrappers/MainWrapper.vue';
    import Button from '@/components/Button.vue';
    import News from '@/components/News.vue';
    import Paginator from '@/components/Paginator.vue';

    import http from '@/methods/http.ts';
    import moment from 'moment';

    @Component({
        components: {
            MainWrapper,
            Button,
            News,
            Paginator
        }
    })
    export default class SingleNews extends Vue {
        news = {};
        moment = moment;
        
        getNews() {
            http(`news/${this.$route.params.id}`, 'get', false, {}).then(r => {
                this.news = r.data;
            })
        }

        created() {
            this.getNews();
        }
    }
</script>